export type Scope = 'community' | 'member';
export type Domain = 'energy' | 'economics';

export interface RankingStrategy {
  id: string;
  apiVersion: string; // e.g. 'v2_0', 'v1_2'
  buildEndpoint: (baseUrl: string, scope: Scope, domain: Domain, entityId: string) => string;
  getRankingConfig: (domain: Domain) => { rankingKpis: string[]; kpiLists: string[][] };
  pageSize: number;          // default 5
  supportsOffset: boolean;   // backend supports offset/cursor
}

function scopePath(scope: Scope): string {
  return scope === 'community' ? 'siteCommunity' : 'siteMember';
}

export const baseStrategy: RankingStrategy = {
  id: 'base',
  apiVersion: 'v2_0',
  buildEndpoint: function (baseUrl, scope, domain, entityId) {
    const sPath = scopePath(scope);
    return `${baseUrl}/community/kpi/${this.apiVersion}/${sPath}/${domain}/ranking/${entityId}`;
  },
  getRankingConfig: (domain) => {
    if (domain === 'energy') {
      return {
        rankingKpis: ['consumption', 'production'],
        kpiLists: [
          ['self_consumption_direct', 'self_consumption_battery', 'from_shared', 'from_grid'],
          ['self_consumption_direct', 'production_to_battery', 'to_shared', 'to_grid'],
        ],
      };
    }
    return {
      rankingKpis: ['total_benefits'],
      kpiLists: [['total_benefits', 'revenues', 'savings']],
    };
  },
  pageSize: 5,
  supportsOffset: true,
};

export const kwickStrategy: RankingStrategy = {
  ...baseStrategy,
  id: 'kwick',
  getRankingConfig: (domain) => {
    if (domain === 'energy') {
      return {
        rankingKpis: ['import_total', 'export_total'],
        kpiLists: [
          ['from_shared', 'from_grid'],
          ['to_shared', 'to_grid'],
        ],
      };
    }
    return {
      rankingKpis: ['total_costs'],
      kpiLists: [['total_costs', 'community_costs', 'other_costs']],
    };
  },
};

export function pickRankingStrategy(org: string): RankingStrategy {
  switch (org) {
    case 'kwick':
      return kwickStrategy;
    default:
      return baseStrategy;
  }
}


